<template>
  <div class="result">

    <div class="result__canvas-wrap">
      <canvas width="500" height="500" ref="canvas" class="result__canvas"></canvas>
    </div>

    <div v-if="!isError && mode == 1" class="result__deco--1">
      <img src="images/draw/other/comic_deco_3.png" alt="">
    </div>
    <div v-if="!isError && mode == 1" class="result__deco--2">
      <img src="images/top/image_chara.png" alt="">
    </div>

    <div v-if="isError" class="result__error">
      <div class="result__text-error">
        <img src="images/draw/text/text_error_en.png" alt="ERROR!" v-if="mode == 0">
        <img src="images/draw/text/text_error_en_2.png" alt="ERROR!" v-if="mode == 1">
      </div>
      <div class="result__text-error-2">
        <img src="images/draw/text/text_failed.png" alt="失敗…" v-if="mode == 0">
        <img src="images/draw/text/text_failed_2.png" alt="失敗…" v-if="mode == 1">
      </div>
    </div>

    <div v-if="!isError" class="result__success">
      <div class="result__text-complete">
        <img src="images/draw/text/text_complete.png" alt="">
      </div>
      <div class="result__text-complete-2">
        <img src="images/draw/text/text_complete_2.png" alt="">
      </div>

      <a v-if="mode == 0" class="result__tw--1" :href="'https://twitter.com/intent/tweet?text=' + shareText" target="_blank">
        <img src="images/draw/btn/btn_twitter.png" alt="完成をツイートする">
      </a>

      <a v-if="mode == 1" class="result__tw--2" :href="'https://twitter.com/intent/tweet?text=' + shareText" target="_blank">
        <img src="images/draw/btn/btn_twitter_2.png" alt="ミッション成功をツイートしろ!">
      </a>

      <div v-if="mode == 1" class="result__tw-text">
        <img src="images/draw/text/text_twitter.png" alt="#01の謎を解け でツイート！">
      </div>

    </div>

    <div class="result__btn">
      <button v-if="isError" v-on:click="toDrawStep" class="c-btn--pixel u-pixel10">→ もう一度チャレンジ!</button>
      <button v-if="!isError && mode == 0" v-on:click="toStory2" class="c-btn--pixel u-pixel10">→ 次に進む!</button>
    </div>

  </div>
</template>

<script>
import * as PIXI from 'pixi.js'
// import { gsap } from 'gsap'
// import { PixiPlugin } from 'gsap/PixiPlugin'

import {DrawCanvas} from '@/assets/js/DrawCanvas.js'

export default {
  props: ['inputText', 'sampleData', 'mode'],
  components: {
  },
  data: function() {
    return {
      container: null,
      isError: false,
      rectGraphics: [],

      shareText: encodeURIComponent("バイナリーコードの謎？0と1でイラストを完成させろ! #01の謎を解け #DrSTONE24巻 #ドクターストーン https://promo.shonenjump.com/drstone/binarymission/"),
    }
  },
  created() {
    if(this.inputText != this.sampleData) {
      this.isError = true;
    }

    if(this.mode == 0) {
      this.digit = {x: 8, y: 8}
    }else {
      this.digit = {x: 32, y: 32}
    }
    this.rectSize = 500 / this.digit.x
  },
  mounted() {
    const app = new PIXI.Application({
      width: 500, 
      height: 500, 
      view: this.$refs.canvas,
      backgroundColor: 0x000000, 
      resolution: window.devicePixelRatio || 1,
    });
    this.container = new PIXI.Container()
    app.stage.addChild(this.container);

    let dc = new DrawCanvas(this.digit, this.rectSize);

    // Rect
    for(let i = 0; i < this.sampleData.length; i++) {
      let g = new PIXI.Graphics()
      let y = Math.floor(i / this.digit.y)
      g.beginFill(0xffffff)
      g.drawRect((i - y * this.digit.y) * this.rectSize, y * this.rectSize, this.rectSize, this.rectSize)
      g.alpha = 1
      if(this.inputText[i] == this.sampleData[i]) {
        if(this.inputText[i] == 0) {
          g.tint = 0xFFFFFF
        }else {
          g.tint = 0x000000
        }
      }else {
        g.tint = 0xFF0000
      }
      
      g.endFill()
      
      this.rectGraphics[i] = g
      this.container.addChild(this.rectGraphics[i])
    }

    // Line
    let lines = dc.drawLine(this.container)
    console.log(lines)
  },
  methods: {
    toDrawStep() {
      if(this.mode == 0) {
        this.$emit("transition", "DrawStep1")
      }else {
        this.$emit("transition", "DrawStep2")
      }
    },
    toStory2() {
      this.$emit("transition", "Story2")
    }
  }
}

</script>

<style lang="scss">

.result {
  padding-top: get_percent(55px);
  position: relative;

  h2 {
    font-size: 3.0rem;
  }

  &__canvas-wrap {
    background: #000;
    height: get_percent(calc_retina3(801px));
    margin: 0 auto get_percent(26px);
    position: relative;
    width: get_percent(calc_retina3(801px));
  }

  &__canvas {
    border: solid 1px #000000;
    height: 100%;
    position: relative;
    vertical-align: bottom;
    width: 100%;
    z-index: 10;
  }

  &__deco--1 {
    margin-top: get_percent(290px);
    position: absolute;
    right: 0;
    top: 0;
    width: get_percent(calc_retina3(403px));
    z-index: 20;
  }

  &__deco--2 {
    position: absolute;
    right: 0;
    top: 0;
    width: get_percent(calc_retina3(312px));
    z-index: 20;
  }

  &__text-error {
    margin: get_percent(calc_retina3(162px)) auto get_percent(calc_retina3(42px));
    width: get_percent(calc_retina3(802px));
  }
  &__text-error-2 {
    margin: 0 auto get_percent(calc_retina3(162px));
    width: get_percent(calc_retina3(205px));
  }

  &__text-complete {
    margin: 0 auto get_percent(calc_retina3(42px));
    width: get_percent(calc_retina3(806px));
  }

  &__text-complete-2 {
    margin: 0 auto get_percent(calc_retina3(52px));
    width: get_percent(calc_retina3(560px));
  }

  &__success {
    position: relative;
    z-index: 30;
  }

  &__tw--1 {
    display: block;
    margin: 0 auto get_percent(calc_retina3(55px));
    width: get_percent(calc_retina3(614px));
  }

  &__tw--2 {
    display: block;
    margin: 0 auto get_percent(calc_retina3(30px));
    width: get_percent(calc_retina3(804px));
  }

  &__tw-text {
    margin: 0 auto get_percent(calc_retina3(150px));
    width: get_percent(calc_retina3(801px));
  }

  &__btn {
    margin-bottom: get_percent(calc_retina3(57px));
  }
}

.draw--1 {
  .result__text-complete-2 {
    margin: 0 auto get_percent(calc_retina3(142px));
  }
}

</style>
